import DefaultSummary from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import Component from '@plone/volto/components/theme/Component/Component';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';

const CustomEventListingItemTemplate = ({ item, isEditMode }) => {
  item.image_field = 'image';
  const language = useSelector((state) => state.intl.locale);
  const taxonomy = useSelector(
    (state) => state.taxonomies['collective.taxonomy.event_type'],
  );
  const getTaxonomyTitle = (token) => {
    if (taxonomy && taxonomy.data?.tree) {
      const term = taxonomy.data.tree.find((term) => term.key === token);
      return term ? term.translations?.[language] ?? term.title : token;
    }
  };
  return (
    <>
      <div className="listing-body">
        <div className="item-metadata">
          {item.start ? (
            <span className="item-date">
              <FormattedDate
                key="hour"
                date={item.start}
                format={{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                }}
                className="hour"
              />
            </span>
          ) : null}
          <span className="event-type">
            {(item?.taxonomy_event_type || [])
              .map((token) => getTaxonomyTitle(token))
              .join(', ')}
          </span>
          {/* {item?.taxonomy_event_type?.map((token, index) => (
            <span className="event-type" key={index}>
              {getTaxonomyTitle(token)}
            </span>
          ))} */}
          {item?.taxonomy_event_type?.length === 0 && (
            <span className="item-category">
              <FormattedMessage id="listing.event" defaultMessage="Event" />
            </span>
          )}
          {item.public === false ? (
            <span className="closed-event">
              (
              <FormattedMessage
                id="listing.closed_event"
                defaultMessage="Closed Event"
              />
              )
            </span>
          ) : null}
          {item?.Subject?.map((tag, index) => (
            <span className="saw-tag" key={index}>
              {tag}
            </span>
          ))}
        </div>
        <DefaultSummary
          item={item}
          HeadingTag="h3"
          hide_description={
            !item.Description ||
            (item.Description && item.Description.trim() === '')
          }
        />
        {item?.preview_text && (
          <p className="listing-text">{item.preview_text}</p>
        )}
        <ConditionalLink
          item={item}
          condition={!isEditMode}
          className="listing-readmore"
        >
          <FormattedMessage id="listing.readmore.more" defaultMessage="Mehr" />
        </ConditionalLink>
      </div>
      <Component
        componentName="PreviewImage"
        item={item}
        alt={item?.image_alternative_text ?? 'Teaserbild einer Veranstaltung'}
      />
    </>
  );
};

export default CustomEventListingItemTemplate;
